<div class="new-home-profile-tab-wrapper">
  <h1 class="new-home-profile-tab-title">{{ "new_home" | localize }}</h1>
  <div class="new-home-profile-tab-toggle-section">
    <div class="new-home-profile-tab-info-group">
      <p class="new-home-profile-tab-description">{{ "new_home_description" | localize }}</p>
      <a class="new-home-profile-tab-link" href="https://help.quantive.com/en/articles/8600687-welcome-to-the-customizable-home" ui-external-link target="_blank">{{ "learn_more" | localize }}</a>
      <p class="new-home-profile-tab-availability-info">{{ "new_home_availability_info" | localize }}</p>
    </div>
    <span>
      <ui-toggle [uiType]="'toggle-text'" [value]="newHomeExpirienceSetting" (toggled)="setNewHomeExpirienceSetting(!newHomeExpirienceSetting)"> </ui-toggle>
    </span>
  </div>
  <img class="new-home-preview-svg" src="/dist/img/home-customizable-preview.svg" alt="" />
</div>
